"use client";

import { useBusinessInfoStore } from "@/modules/store/businessInfoStore";
import LoadingPage from "../commons/Loading";

const BusinessLoadingOverlay = () => {
    const isSwitchingBusiness = useBusinessInfoStore((state) => state.isSwitchingBusiness);

    if (!isSwitchingBusiness) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white dark:bg-black">
            <LoadingPage style={{ height: 'auto' }} />
        </div>
    );
};

export default BusinessLoadingOverlay;
